/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCube } from '../../factoriesAny.js';
export var cubeDependencies = {
  typedDependencies: typedDependencies,
  createCube: createCube
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCube.generated.js
// module id = 1383
// module chunks = 0